<template>
    <form @submit.prevent="handleSubmit(item)" novalidate>
        <div v-if="item.fullNumber" :class="{ 'form-group': true}">
            <label for="_number" class="control-label">Numer umowy</label>
            <h3>{{ item.fullNumber }}</h3>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.date) }">
            <label for="_data" class="control-label">Data zawarcia umowy</label>
            <el-date-picker
                    v-model="item.date"
                    type="date"
                    placeholder="Data">
            </el-date-picker>
            <span v-if="errors && errors.date" class="help-block" id="_data_helpBlock">{{ errors.date }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.customer) }">
            <label for="_customer" class="control-label">Klient</label>
            <dropdown-search :elements="customersList" emptyValue="Wybierz klienta"
                             v-model="item.customer" nameField="fullName" valueField="@id" :isSearch="true"
                             @change="setupCommission"/>
            <span v-if="errors && errors.customer" class="help-block" id="_customer_helpBlock">{{ errors.customer
                }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.currency) }">
            <label for="_currency" class="control-label">Waluta</label>
            <dropdown-search x :elements="currencyTypes" emptyValue="Wybierz walutę"
                             v-model="item.currency" valueField="@id" nameField="name"
                             @change="setupBankAccount"/>
            <span v-if="errors && errors.currency" class="help-block" id="_currency_helpBlock">{{ errors.currency
                }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.commission) }">
            <label for="_commission" class="control-label">Prowizja</label>
            <b-input-group right="%">
                <b-form-input v-model="item.commission" type="number" id="_commission"></b-form-input>
            </b-input-group>
            <span v-if="errors && errors.commission" class="help-block" id="_commission_helpBlock">{{ errors.commission
                }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.bankAccount) }">
            <label for="_bankAccount" class="control-label">Konto bankowe</label>
            <b-form-input v-model="item.bankAccount" id="_bankAccount"></b-form-input>
            <span v-if="errors && errors.bankAccount" class="help-block"
                  id="_bankAccount_helpBlock">{{ errors.bankAccount
                }}</span>
        </div>
        <div v-show="showAdditionalBankAccount" :class="{ 'form-group': true, 'has-error': (errors && errors.bankAccount) }">
            <label for="_bankAccountAdditional" class="control-label">Dodatkowe konto bankowe</label>
            <b-form-input v-model="item.bankAccountAdditional" id="_bankAccountAdditional"></b-form-input>
            <span v-if="errors && errors.bankAccountAdditional" class="help-block"
                  id="_bankAccountAdditional_helpBlock">{{ errors.bankAccountAdditional
                }}</span>
        </div>
        <div v-if="item.status" :class="{ 'form-group': true }">
            <label for="_status" class="control-label">Status</label>
            <div><span class="element_status" :class="item.status">{{ item['status'] | translate }}</span></div>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.comments) }">
            <label for="_comments" class="control-label">Uwagi</label>
            <textarea v-model="item.comments" type="text" id="_comments" class="form-control"></textarea>
            <span v-if="errors && errors.comments" class="help-block" id="_comments_helpBlock">{{ errors.comments
                }}</span>
        </div>
        <my-button text="Zapisz" icon="tick" type="submit"/>
    </form>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    props: {
      handleSubmit: {
        type: Function,
        required: true,
      },
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object
      },
      initialValues: {
        type: Object
      }
    },
    data: function () {
      return {
        showAdditionalBankAccount: false,
      }
    },

    methods: {
      setupCommission (event) {
        this.item.commission = parseFloat(event.commission)
      },
      setupBankAccount (event) {
        if (event.foreign) {
          this.item.bankAccount = this.company.bankAccount.numberEUR;
          this.item.bankAccountAdditional = this.company.bankAccount.numberPLN;
          this.showAdditionalBankAccount = true;
        } else {
          this.item.bankAccount =  this.company.bankAccount.numberPLN;
          this.item.bankAccountAdditional = '';
          this.showAdditionalBankAccount = false;
        }
      }
    },
    computed: {
      item: function () {
        let data = this.initialValues ? this.initialValues : this.values;
         if(data.currency && data.currency.foreign){
          this.showAdditionalBankAccount = true;
        } else {
          this.showAdditionalBankAccount = false;
        }
        return data;

      },
      ...mapGetters({
        customersList: 'agreement/customer/items',
        currencyTypes: 'config/config/currencyTypes',
        company: 'config/config/company'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// FormGeneral.vue?15b56a5c